import { computed } from 'vue'

import type { PlaygamaCTRContext } from '@/modules/analytics/types'

declare const guard: unique symbol

type CtrContextInput = Partial<PlaygamaCTRContext>

export type CtrContext = CtrContextInput & {
    readonly [guard]: 'use useCtrContext composable'
}

function brandCtrContext(context: CtrContextInput): CtrContext {
    return context as CtrContext
}

export function useCtrContext(getContext: () => CtrContextInput) {
    return computed(() => brandCtrContext(getContext()))
}

export function useCtrContexts<T>(
    getItems: () => readonly T[],
    getContext: (item: T, index: number, items: readonly T[]) => CtrContextInput | undefined,
) {
    return computed(() => {
        const items = getItems()

        return items.map((item, index) => {
            const context = getContext(item, index, items)
            return context ? brandCtrContext(context) : undefined
        })
    })
}
